import { authwsEnvironment } from '../authws-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { AuthHeaders } from '../../../models/auth-headers';
import { accountProductRelationshipSchema } from '../schemas/account-product-relationship.schema';
import { fromFetch } from 'rxjs/fetch';

/**
 * Get the details of the relationship between an account and a Trimble Maps product
 * @param product Trimble Maps product name
 * @param accountId Id of the Account
 * @returns Account Product Relationship
 */
export function getProductsProductAccounts(
  this: unknown,
  product: string,
  accountId: number
) {
  return fromFetch(
    new Request(
      `${authwsEnvironment.resolve(this).productsUrl}/${encodeURIComponent(
        product
      )}/accounts/${encodeURIComponent(accountId)}`,
      {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
      }
    )
  ).pipe(selectData(accountProductRelationshipSchema));
}
